import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit {
  places: any = [
    // { moduleName: 'patientList', displayName: 'Patient List', isVisible: true },
    // { moduleName: 'aboutPatient', displayName: 'Case History', isVisible: true },
    // { moduleName: 'patientImages', displayName: 'Patient Images' },
    // { moduleName: 'reports', displayName: 'Reports', isVisible: false }
  ];
  selectedRole: any;
  currentModule: any;
  viewerOpenPlace: any;
  selectedPlace: string = '';

  constructor(public router: Router, public commonService: CommonService, private authService: AuthService,) { }

  ngOnInit(): void {
    this.commonService.selectedPlace = this.commonService.ProjectLSData['sideBarPlace'] ? this.commonService.ProjectLSData['sideBarPlace'] : 'patientList';
    this.commonService.setCurrentPlace(this.commonService.selectedPlace);

    this.commonService.currentRole.subscribe(role => {
      if (role !== this.selectedRole) {
        this.selectedRole = role;
        this.authService.getRolePlaces(this.selectedRole).subscribe((result: any) => {
          if (result.data.places.length) {
            this.places = [];
            result.data.places.forEach((item: any) => {
              this.places.push({
                'displayName': item,
                'moduleName': item == "Patient List" ? "patientList" : item == "Case History" ? 'aboutPatient' : item.toLowerCase(),
                'isVisible': true
              });
            });
            if (!this.commonService.ProjectLSData.sideBarPlace) {
              this.selectedPlace = this.commonService.ProjectLSData['sideBarPlace'] = (this.selectedRole == "APPLICATION_ADMIN") ? 'users' : 'patientList';
              this.commonService.setProjectLSData();
              this.commonService.setCurrentPlace(this.selectedPlace);
            } else {
              this.selectedPlace = this.commonService.ProjectLSData.sideBarPlace;
            }
          }

          this.router.navigate([`/mainboard/${(role == "APPLICATION_ADMIN") ? 'users' : 'patientList'}`]);

        });
      }
    });
  }

  changePlace(place: any) {
    delete this.commonService.ProjectLSData['currentRoute'];
    this.router.navigate([`/mainboard/${place}`]);
    this.selectedPlace = this.commonService.ProjectLSData['sideBarPlace'] = (place == 'patientGallery') ? 'patientList' : place;
    this.commonService.setProjectLSData();
    this.commonService.setCurrentPlace(this.commonService.selectedPlace);
  }

}
